import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <article>
      <h1 className="font-serif text-3xl">Assessment not found</h1>
      <p className="mt-2">
        <Link to="/" className="text-brand hover:text-brand-dark">
          Back to assessments
        </Link>
      </p>
    </article>
  );
}
